<div class="flex flex-col p-6 w-[872px] h-[540px] p-16">
	<div class="flex justify-center">
		<img
			class="w-auto"
			src="/assets/images/leap/invalid-matter-type.png"
			alt="invalid matter type"
		/>
	</div>
	<div class="flex justify-center mt-8">
		<h1 class="text-3xl font-medium">Oops! We Hit a Snag</h1>
	</div>
	<div class="flex justify-center">
		<div class="text-sm text-center">
			This matter type (ID: {{ matterTypeId }}) isn't supported by Closer.
			Please contact LEAP support with this provided message for assistance.
		</div>
	</div>
	<div class="flex justify-center mt-8">
		<app-anchor
			[external]="true"
			[url]="'https://help.leaplegalsoftware.ca/s/community'"
			class="mt-2 rounded-lg bg-green p-3"
			><span class="text-white no-underline">Contact LEAP</span></app-anchor
		>
	</div>
</div>
